import { useQuery } from "@tanstack/react-query";
import { getBillOperations } from "../api/billOperations";

export const useBillOperations = (billId: number | null | undefined) => {
  return useQuery({
    queryKey: ["bill-operations", billId],
    queryFn: () => getBillOperations(billId as number),
    enabled: billId != null,
    // Без кеш — модалът се монтира с `destroyOnHidden`, всяко отваряне
    // прави свеж request. Иначе при добавяне/сторно отвън, при повторно
    // отваряне ще видим стари данни до първото invalidate.
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: "always",
  });
};
